import React from "react";

export const ArrowForwardIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M5.6002 9.65001C5.49186 9.54168 5.4357 9.40835 5.4317 9.25001C5.42736 9.09168 5.47936 8.95835 5.5877 8.85001L7.8627 6.57501H2.5252C2.36686 6.57501 2.23153 6.51868 2.1192 6.40601C2.00653 6.29368 1.9502 6.15835 1.9502 6.00001C1.9502 5.84168 2.00653 5.70635 2.1192 5.59401C2.23153 5.48135 2.36686 5.42501 2.5252 5.42501H7.8627L5.5877 3.15001C5.47936 3.04168 5.42736 2.90835 5.4317 2.75001C5.4357 2.59168 5.49186 2.45835 5.6002 2.35001C5.70853 2.25001 5.84186 2.20001 6.0002 2.20001C6.15853 2.20001 6.29186 2.25001 6.4002 2.35001L9.6502 5.60001C9.70853 5.65001 9.7502 5.71035 9.7752 5.78101C9.8002 5.85201 9.8127 5.92501 9.8127 6.00001C9.8127 6.07501 9.8002 6.14585 9.7752 6.21251C9.7502 6.27918 9.70853 6.34168 9.6502 6.40001L6.4002 9.65001C6.29186 9.75835 6.15853 9.81051 6.0002 9.80651C5.84186 9.80218 5.70853 9.75001 5.6002 9.65001Z"
      fill="#767676"
    />
  </svg>
);
